import { XMarkIcon } from "@heroicons/react/24/outline";
import toast, { ToastBar, Toaster, DefaultToastOptions } from "react-hot-toast";

export default function TaostManager() {
  return (
    <Toaster toastOptions={toastOptions}>
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== "loading" && (
                <button
                  onClick={() => toast.dismiss(t.id)}
                  className="p-2 bg-gray-200/20 hover:bg-gray-200/40 border-none rounded-full"
                >
                  <XMarkIcon className="size-4" />
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}

const toastOptions: DefaultToastOptions = {
  style: {
    borderRadius: "10px",
    color: "#fff",
    minWidth: "200px",
  },
  duration: 3000,
  className: "!bg-gray-400/60 filter backdrop-blur-md shadow-md ",
  position: "bottom-right",
};
